const { SWITCH_MODE_FAILURE, SWITCH_MODE_REQUEST } = require('../lib/constants').default;

export default function(state = null, action = {}) {
  switch (action.type) {
    case 'SET_CURRENT_SUBSCRIPTION':
      return action.subscription.renewalStatus === 'ON';
    case SWITCH_MODE_REQUEST:
    case SWITCH_MODE_FAILURE:
      return !state;
    default:
      return state;
  }
}

export const isSubscriptionEnabledSelector = state => state.subscriptionSwitch;
